module.exports = __webpack_public_path__ + "static/img/tray.13065eff.png";